import { Link } from "react-router-dom";
import { LOGO_URL } from "@/lib/checkout";

export const Logo = ({ imgClass = "h-10", plate = false }) => {
  const img = (
    <img src={LOGO_URL} alt="CommandCenterADHD" width="640" height="316" className={`${imgClass} w-auto object-contain`} />
  );
  return (
    <Link to="/" data-testid="brand-logo" className="inline-flex items-center gap-2">
      {plate ? (
        <span className="inline-flex items-center justify-center rounded-xl bg-white p-1.5 shadow-sm">
          {img}
        </span>
      ) : (
        img
      )}
    </Link>
  );
};

export const SiteHeader = ({ right = null }) => (
  <header className="sticky top-0 z-50 border-b border-white/10 bg-[#0B132B]/85 backdrop-blur-md">
    <div className="mx-auto flex max-w-[1100px] items-center justify-between px-6 py-3">
      <Logo imgClass="h-12 sm:h-14" />
      {right}
    </div>
  </header>
);
